<template>
  <div>
    <div class="form-control-group">
      <div class="form-control form-pikerbox" readonly>
        <ul class="form-pikerbox-main" v-if="selectData&&selectData.length>0" @click="onSelectEmployee">
          <li v-for="(item,index) in selectData" :key="index">
            {{item.RealName}}
            <i class="fa fa-remove" @click.stop="selectData.splice(index,1)"></i>
          </li>
        </ul>
        <div class="form-control-placeholder" @click="onSelectEmployee" v-else>{{placeholder}}</div>
      </div>
      <i class="btn btn-default fa fa-user" @click="onSelectEmployee"></i>
    </div>
    <employee-picker :default-select="selectData" :multiple="multiple" @pickerCallBack="onSelectEmployeeCallBack" v-if="visible"></employee-picker>
  </div>
</template>
<script>
import EmployeePicker from "@/modules/sys/components/picker/employee.vue";

export default {
  name: "employee-select",
  components: { EmployeePicker },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    placeholder: {
      type: String,
      default: "请选择人员"
    }
  },
  data() {
    return {
      selectData: this.value,
      visible: false
    };
  },
  watch: {
    value(newVal) {
      this.selectData = newVal;
    },
    selectData: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  },
  methods: {
    onSelectEmployee() {
      this.visible = true;
    },
    onSelectEmployeeCallBack(res) {
      this.visible = false;
      if(!res)return
      if (this.multiple) {
           this.selectData = res
          /** 
        res.forEach(element => {
          let i = this.selectData.findIndex(x => x.Id === element.Id);
          if (i > -1) {
            this.selectData.splice(i,1,element);
          } else {
            this.selectData.push(element);
          }
        });
        */
      } else {
        this.selectData = [res];
      }
    }
  }
};
</script>

